<div class="container-fluid v2-active" [class.is-dialog]="isForcedSelection">
    <div class="page-header mb-5" [class.mt-5]="!isForcedSelection">
        <h1>{{ 'fontesTrafego.title' | transloco }}</h1>
        <p>{{ 'fontesTrafego.subtitle' | transloco }}</p>
        @if (isForcedSelection) {
            <p class="forced-hint mb-0 mt-2">{{ 'fontesTrafego.forcedHint' | transloco }}</p>
        }
        @if (totalDisponivel > 0) {
            <p class="text-secondary small mb-0 mt-2">
                {{ 'fontesTrafego.limitLabel' | transloco: { count: totalDisponivel } }}
                ·
                {{ 'fontesTrafego.selectedCount' | transloco: { selected: selectedIds.size, limit: totalDisponivel } }}
            </p>
        }
    </div>

    <div class="row g-3">
        @for (network of networks; track network.id) {
            <div class="col-12 col-md-6">
                @let active = isSelected(network.id);
                <article
                    class="network-card d-flex align-items-center justify-content-between gap-3"
                    [class.is-active]="active"
                    [class.is-busy]="isSaving"
                >
                    <div class="d-flex align-items-center gap-3 min-w-0">
                        <img class="network-icon" [src]="network.iconPath" [alt]="network.label" />
                        <div class="min-w-0">
                            <h2 class="h6 mb-1 text-truncate">{{ network.label }}</h2>
                            <span class="status-chip" [class.is-active]="active">
                                {{
                                    (active ? 'fontesTrafego.status.active' : 'fontesTrafego.status.inactive')
                                        | transloco
                                }}
                            </span>
                        </div>
                    </div>

                    <mat-slide-toggle
                        color="accent"
                        [checked]="active"
                        [disabled]="isSaving"
                        (change)="onToggle(network, $event)"
                    ></mat-slide-toggle>
                </article>
            </div>
        }
    </div>

    @if (canShowConfirm) {
        <div class="forced-actions">
            <button
                mat-flat-button
                class="confirm-selection"
                type="button"
                [disabled]="isSaving"
                (click)="confirmSelection()"
            >
                {{ 'fontesTrafego.confirmSelection' | transloco }}
            </button>
        </div>
    }
</div>
